import _ from 'lodash'
import { mapGetters } from 'vuex'

const TODAYS_SECONDS = (24 * 60 * 60) - 1
export default {
  computed: {
    ...mapGetters('services', ['currentService']),
    ...mapGetters('user', ['userInfo'])
  },
  data () {
    return {
      meta: {},
      rows: [],
      selectedRow: '',
      page: 0,
      pageLimit: 10
    }
  },
  methods: {
    _extractFormattedFilters (filters) {
      let formattedFilters = {}
      _.forIn(filters, filter => {
        if (filter.selected) {
          formattedFilters[filter.key] = {
            max: (filter.type === 'date') ? (((new Date(filter.max)).getTime() / 1000) + TODAYS_SECONDS) : filter.max,
            min: (filter.type === 'date') ? (((new Date(filter.min)).getTime() / 1000) + TODAYS_SECONDS) : filter.min,
            type: (filter.mode === undefined) ? 'exact' : filter.mode,
            value: (filter.type === 'date') ? (((new Date(filter.value)).getTime() / 1000) + TODAYS_SECONDS) : filter.value
          }
        }
      })
      return formattedFilters
    },
    _prepareCountries (countries) {
      let formattedCountries = []
      _.forIn(countries, (value, key) => {
        formattedCountries.push({
          key: key,
          label: value.countryName
        })
      })
      return formattedCountries
    },
    _prepareCurrencies (currency) {
      let formattedCurrencies = []
      _.forIn(currency, (value, key) => {
        formattedCurrencies.push({
          key: key,
          label: value.currencyName
        })
      })
      return formattedCurrencies
    },
    _prepareStatuses (statuses) {
      let formattedStatuses = []
      _.forIn(statuses, (value, key) => {
        formattedStatuses.push({
          key: key,
          label: value.statusName
        })
      })
      return formattedStatuses
    },
    _preparePayerClients (payerClients) {
      let payerClientsObj = {}
      _.forIn(payerClients, (clientSection, countryCode) => {
        _.forIn(clientSection, client => {
          client.countryCode = countryCode
        })
        _.merge(payerClientsObj, clientSection)
      })
      let formattedPayerClients = []
      _.forIn(payerClientsObj, (value, key) => {
        formattedPayerClients.push({
          countryCode: value.countryCode,
          key: key,
          label: value.payerClientName
        })
      })
      return formattedPayerClients
    },
    nextPage (event) {
      // TODO: Implement a check for the next page
      if (this.rows.length > 1) {
        ++this.page
      }
      this.rebuildTable(event.filters, this.page)
    },
    selectRow (row) {
      if (this.selectedRow !== row) {
        this.selectedRow = row
      } else {
        this.selectedRow = {}
      }
    },
    prevPage (event) {
      if ((this.page - 1) >= 0) {
        this.page = this.page - 1
      }
      this.rebuildTable(event.filters, this.page)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DataTable.js